import { MultiChoiceCardOrder } from '@/models'
import { DotationOrderListItem, OrderBeneficiary } from '../types/dotationOrderList'

function formatDate(value?: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString('fr-FR')
}

function mapLines(order: MultiChoiceCardOrder): OrderBeneficiary[] {
  const lines = order.multiChoiceCardOrderLines || []
  return lines.map(line => ({
    id: line.id,
    firstname: line.customer?.firstname || '',
    lastname: line.customer?.lastname || '',
    email: line.customer?.email || '',
    amount: typeof line.amount === 'number'
      ? line.amount
      : (line.amountCents || 0) / 100,
    customerId: line.customerId || line.customer?.id
  }))
}

export function mapOrderToListItem(order: MultiChoiceCardOrder): DotationOrderListItem {
  const amount = typeof order.amount === 'number'
    ? order.amount
    : (order.amountCents || 0) / 100

  const status = order.payedAt
    ? 'paid'
    : (order.status || 'draft')

  return {
    id: order.id,
    reference: order.number,
    name: order.ursafEvent?.name
      || order.multiChoiceGiftCard?.name
      || order.program?.name
      || order.id,
    date: formatDate(order.createdAt),
    createdAt: order.createdAt ? String(order.createdAt) : '',
    amount,
    status,
    scheduledAt: order.scheduledAt,
    programId: order.programId || order.program?.id,
    programName: order.program?.name,
    giftCardName: order.multiChoiceGiftCard?.name,
    beneficiaries: mapLines(order)
  }
}
